var taxonomyItems = {
    categories: [
        {
            title: 'AI + machine learning',
            icon: 'CategoryAIMachineLearning',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'ai-machine-learning'
                }
            }
        },
        {
            title: 'Compliance + legal',
            icon: 'Compare',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'compliance-legals'
                }
            }
        },
        {
            title: 'Human resources',
            icon: 'PeopleAdd',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'human-resources'
                }
            }
        },
        {
            title: 'Operations + Supply Chain',
            icon: 'WorkFlow',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'operations'
                }
            }
        },
        {
            title: 'Analytics',
            icon: 'analyticsview',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'analytics'
                }
            }
        },
        {
            title: 'Customer service',
            icon: 'Telemarketer',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'customer-service'
                }
            }
        },
        {
            title: 'Internet of things',
            icon: 'SplitObject',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'internet-of-things'
                }
            }
        },
        {
            title: 'Productivity',
            icon: 'SpeedHigh',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'productivity'
                }
            }
        },
        {
            title: 'Collaboration',
            icon: 'Transition',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'collaboration'
                }
            }
        },
        {
            title: 'Finance',
            icon: 'Money',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'finance'
                }
            }
        },
        {
            title: 'IT management tools',
            icon: 'SecurityGroup',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'it-management-tools'
                }
            }
        },
        {
            title: 'Project management',
            icon: 'Assign',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'project-management'
                }
            }
        },
        {
            title: 'Commerce',
            icon: 'ShoppingCart',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'commerce'
                }
            }
        },
        {
            title: 'Geolocation',
            icon: 'LocationOutline',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'geolocation'
                }
            }
        },
        {
            title: 'Marketing',
            icon: 'Megaphone',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'marketing'
                }
            }
        }
    ],
    industries: [
        {
            title: 'Financial services',
            icon: 'Financial',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'financial-services'
                }
            }
        },
        {
            title: 'Media + communications',
            icon: 'Media',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'media-communications'
                }
            }
        },
        {
            title: 'Defense + intelligence',
            icon: 'Shield',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'defense-and-intelligence'
                }
            }
        },
        {
            title: 'Government',
            icon: 'Flag',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'government'
                }
            }
        },
        {
            title: 'Non-Profit + IGO',
            icon: 'Heart',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'nonprofit'
                }
            }
        },
        {
            title: 'Distribution',
            icon: 'DistributeDown',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'distribution'
                }
            }
        },
        {
            title: 'Healthcare',
            icon: 'Health',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'healthcare'
                }
            }
        },
        {
            title: 'Professional services',
            icon: 'Suitcase',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'professional-services'
                }
            }
        },
        {
            title: 'Education',
            icon: 'Education',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'education'
                }
            }
        },
        {
            title: 'Hospitality + travel',
            icon: 'Airplane',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'hospitality-and-travel'
                }
            }
        },
        {
            title: 'Retail',
            icon: 'BusinessHoursSign',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'retail-and-consumer-goods'
                }
            }
        },
        {
            title: 'Energy',
            icon: 'Lightbulb',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'energy'
                }
            }
        },
        {
            title: 'Manufacturing',
            icon: 'Manufacturing',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'manufacturing-resources'
                }
            }
        },
        {
            title: 'Sustainability',
            icon: 'Cotton',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'sustainability'
                }
            }
        }
    ]
};
var unifiedTaxonomyItems = {
    categories: [
        {
            title: 'AI + machine learning',
            icon: 'CategoryAIMachineLearning',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'ai-plus-machine-learning'
                }
            }
        },
        {
            title: 'Databases',
            icon: 'Database',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'databases'
                }
            }
        },
        {
            title: 'Internet of Things',
            icon: 'SplitObject',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'internet-of-things'
                }
            }
        },
        {
            title: 'Networking',
            icon: 'Networking',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'networking'
                }
            }
        },
        {
            title: 'Analytics',
            icon: 'analyticsview',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'analytics'
                }
            }
        },
        {
            title: 'Developer Tools',
            icon: 'DeveloperTool',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'developer-tools'
                }
            }
        },
        {
            title: 'IT + Management Tools',
            icon: 'SecurityGroup',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'management-tools'
                }
            }
        },
        {
            title: 'Operations + Supply Chain',
            icon: 'WorkFlow',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'operations'
                }
            }
        },
        {
            title: 'Blockchain',
            icon: 'Blockchain',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'blockchain'
                }
            }
        },
        {
            title: 'DevOps',
            icon: 'Devops',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'devops'
                }
            }
        },
        {
            title: 'Marketing',
            icon: 'Megaphone',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'marketing'
                }
            }
        },
        {
            title: 'Productivity',
            icon: 'SpeedHigh',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'productivity'
                }
            }
        },
        {
            title: 'Collaboration',
            icon: 'Transition',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'collaboration'
                }
            }
        },
        {
            title: 'Finance',
            icon: 'Money',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'finance'
                }
            }
        },
        {
            title: 'Media',
            icon: 'Media',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'media'
                }
            }
        },
        {
            title: 'Project management',
            icon: 'Assign',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'project-management'
                }
            }
        },
        {
            title: 'Compliance + legal',
            icon: 'Compare',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'compliance-legals'
                }
            }
        },
        {
            title: 'Geolocation',
            icon: 'LocationOutline',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'geolocation'
                }
            }
        },
        {
            title: 'Microsoft Entra ID',
            icon: 'MicrosoftEntraId',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'entra-id'
                }
            }
        },
        {
            title: 'Sales',
            icon: 'Shop',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'sales'
                }
            }
        },
        {
            title: 'Compute',
            icon: 'Compute',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'compute'
                }
            }
        },
        {
            title: 'Human resources',
            icon: 'PeopleAdd',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'human-resources'
                }
            }
        },
        {
            title: 'Migration',
            icon: 'Migration',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'migration'
                }
            }
        },
        {
            title: 'Security',
            icon: 'Security',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'security'
                }
            }
        },
        {
            title: 'Containers',
            icon: 'Containers',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'containers'
                }
            }
        },
        {
            title: 'Identity',
            icon: 'Identity',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'identity'
                }
            }
        },
        {
            title: 'Mixed Reality',
            icon: 'MixReality',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'mixed-reality'
                }
            }
        },
        {
            title: 'Storage',
            icon: 'Storage',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'storage'
                }
            }
        },
        {
            title: 'Customer service',
            icon: 'Telemarketer',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'customer-service'
                }
            }
        },
        {
            title: 'Integration',
            icon: 'Integration',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'integration'
                }
            }
        },
        {
            title: 'Monitoring + Diagnostics',
            icon: 'MonitoringAndDiagnostics',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'monitoring-and-diagnostics'
                }
            }
        },
        {
            title: 'Web',
            icon: 'Globe',
            navigateOptions: {
                type: 'App',
                query: {
                    category: 'web'
                }
            }
        }
    ],
    industries: [
        {
            title: 'Financial services',
            icon: 'Financial',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'financial-services'
                }
            }
        },
        {
            title: 'Media + communications',
            icon: 'Media',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'media-communications'
                }
            }
        },
        {
            title: 'Defense + intelligence',
            icon: 'Shield',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'defense-and-intelligence'
                }
            }
        },
        {
            title: 'Government',
            icon: 'Flag',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'government'
                }
            }
        },
        {
            title: 'Non-Profit + IGO',
            icon: 'Heart',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'nonprofit'
                }
            }
        },
        {
            title: 'Distribution',
            icon: 'DistributeDown',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'distribution'
                }
            }
        },
        {
            title: 'Healthcare',
            icon: 'Health',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'healthcare'
                }
            }
        },
        {
            title: 'Professional services',
            icon: 'Suitcase',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'professional-services'
                }
            }
        },
        {
            title: 'Education',
            icon: 'Education',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'education'
                }
            }
        },
        {
            title: 'Hospitality + travel',
            icon: 'Airplane',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'hospitality-and-travel'
                }
            }
        },
        {
            title: 'Retail',
            icon: 'BusinessHoursSign',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'retail-and-consumer-goods'
                }
            }
        },
        {
            title: 'Energy',
            icon: 'Lightbulb',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'energy'
                }
            }
        },
        {
            title: 'Manufacturing',
            icon: 'Manufacturing',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'manufacturing-resources'
                }
            }
        },
        {
            title: 'Sustainability',
            icon: 'Cotton',
            navigateOptions: {
                type: 'App',
                query: {
                    industry: 'sustainability'
                }
            }
        }
    ]
};

export { taxonomyItems, unifiedTaxonomyItems };
